<template>
  <div class="min-h-screen bg-gray-50">
    <NavBar />
    <div class="pt-24">
      <Suspense>
        <template #default>
          <router-view/>
        </template>
        <template #fallback>
          <div class="flex items-center justify-center min-h-screen">
            <div class="text-gray-600">Loading...</div>
          </div>
        </template>
      </Suspense>
      <Footer />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'

export default defineComponent({
  name: 'App',
  components: {
    NavBar,
    Footer,
  }
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
